import React from 'react'
import SpeakerIcon from '../../icons/speakerIcon'
import styles from './readAloudButton-style.css'
import useReadAloudStatus from '../../hooks/useReadAloudStatus'

// implementation of "leseweb" (leseweb.dk) for reading aloud the text on the page

function ReadAloudButton() {
  const { isReadingAloud, lesewebInitialized } = useReadAloudStatus()

  const handleClick = () => {
    if (isReadingAloud) {
      window.vFact_dostop()
    } else {
      window.vFact_doplay()
    }
  }

  return (
    <button
      className={styles.readAloudButton}
      onClick={handleClick}
      disabled={!lesewebInitialized}
    >
      <SpeakerIcon /> {isReadingAloud ? 'Stop oplæsning' : 'Læs op'}
    </button>
  )
}

export default ReadAloudButton



// WEBPACK FOOTER //
// ./src/components/ReadAloudButton/ReadAloudButton.js